
const desktopPage = <HTMLElement>document?.querySelector(".desktopPage");


export function revealDesktopPage() {
    desktopPage.style.display = 'flex';
}